import { defineRecipe } from '@chakra-ui/react';

export const closeButtonRecipe = defineRecipe({
  className: 'ac-close-button',
  base: {},
});
